import { useContext } from 'react'

import { UserContext } from '@doist/marketist'

import { Footer, Navbar, Seo } from 'components'
import { BlogRoll } from 'components/BlogRoll/BlogRoll'
import { IntegrationsBannerCommon } from 'components/IntegrationsBanner/IntegrationsBanner'
import { appendSlackAltUTM } from 'components/slack-alternative/appendSlackAlternativeUTM'
import { FeatureSection } from 'components/slack-alternative/FeatureSection/FeatureSection'
import { Intro } from 'components/slack-alternative/Intro/intro'
import { JournalistQuotes } from 'components/slack-alternative/JournalistQuotes/JournalistQuotes'
import { MadeByDoist } from 'components/slack-alternative/MadeByDoist/MadeByDoist'
import { SlackAltCTA } from 'components/slack-alternative/SlackAltCTA/SlackAltCTA'
import { SlackVideoFeature } from 'components/slack-alternative/SlackVideoFeature/SlackVideoFeature'
import { Teams } from 'components/slack-alternative/Teams/teams'
import { UserQuotes } from 'components/slack-alternative/UserQuotes/UserQuotes'
import { Statement } from 'components/Statement/Statement'
import { VideoSection } from 'components/VideoSection/VideoSection'
import { GetServerSidePropsContext } from 'next'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { getCommonServerSideProps } from 'services'
import { getOgImageURL } from 'services/ogimage'

const NS = 'slackalternative'

function SlackAlternative() {
    const { isAuthenticated } = useContext(UserContext)
    const { t, i18n } = useTranslation(NS)

    return (
        <>
            <Navbar isAuth={isAuthenticated} />
            <Seo
                path="/slack-alternative"
                title={t('seoTitle')}
                description={t('seoDescription')}
                lang={i18n.language}
                images={[
                    {
                        url: getOgImageURL('og-image-slack-alternative.jpg'),
                        alt: t('seoImageAlt'),
                    },
                ]}
            />
            <Intro />
            <section style={{ marginBlockEnd: 'var(--space-48)' }}>
                <VideoSection variant="sunray" />
            </section>
            <Teams />
            <JournalistQuotes />
            <FeatureSection />
            <Statement>{t('collaboration')}</Statement>
            <SlackVideoFeature />
            <IntegrationsBannerCommon />
            <UserQuotes />
            <MadeByDoist />
            <SlackAltCTA />
            <BlogRoll utmMethod={appendSlackAltUTM} />
            <Footer />
        </>
    )
}

export async function getServerSideProps(ctx: GetServerSidePropsContext) {
    const { locale, ...commonProps } = await getCommonServerSideProps(ctx)

    return {
        props: {
            ...commonProps,
            ...(await serverSideTranslations(locale, [NS, 'common'])),
        },
    }
}

export default SlackAlternative
